import { useLang } from "@/context/LanguageContext";
import { t } from "@/data/translations";
import { Car, Users, Truck, Package } from "lucide-react";
import { motion } from "framer-motion";

const fleetIcons = [Car, Users, Truck, Package];

export default function AboutUs() {
  const { lang } = useLang();
  const about = t.about[lang];

  return (
    <div>
      {/* Hero */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 -z-10">
          <img
            src="https://images.unsplash.com/photo-1724221073240-d62768034bf9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwyfHxldXJvcGVhbiUyMGhpZ2h3YXklMjBzdW5yaXNlfGVufDB8fHx8MTc3NTI5NzQyNHww&ixlib=rb-4.1.0&q=85"
            alt=""
            className="w-full h-full object-cover opacity-10"
          />
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-10 sm:py-16 md:py-28">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
            <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] font-semibold text-[#FF3B30] mb-3 sm:mb-4" data-testid="about-overline">
              {lang === "cs" ? "O SPOLECNOSTI" : "ABOUT COMPANY"}
            </p>
            <h1
              data-testid="about-title"
              className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold tracking-tighter leading-none text-[#0A0B10] mb-6 sm:mb-8"
            >
              {about.title}
            </h1>
            <div className="max-w-3xl space-y-4 sm:space-y-6">
              <p className="text-sm sm:text-base lg:text-lg text-[#666666] leading-relaxed" data-testid="about-story">
                {about.story}
              </p>
              <p className="text-sm sm:text-base lg:text-lg text-[#666666] leading-relaxed" data-testid="about-story-2">
                {about.storyP2}
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Team */}
      <section className="bg-[#F5F5F5] border-y border-[#E5E5E5]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-24">
          <h2 className="font-heading text-xl sm:text-2xl md:text-3xl font-medium tracking-tight text-[#0A0B10] mb-3 sm:mb-4" data-testid="team-title">
            {about.teamTitle}
          </h2>
          <p className="text-sm sm:text-base text-[#666666] leading-relaxed max-w-xl" data-testid="team-desc">
            {about.teamDesc}
          </p>
        </div>
      </section>

      {/* Fleet */}
      <section className="max-w-7xl mx-auto px-4 sm:px-6 py-12 sm:py-16 md:py-24">
        <h2 className="font-heading text-xl sm:text-2xl md:text-3xl font-medium tracking-tight text-[#0A0B10] mb-8 sm:mb-12" data-testid="fleet-title">
          {about.fleetTitle}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-8">
          {about.fleet.map((vehicle, i) => {
            const Icon = fleetIcons[i];
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 15 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.1 }}
                data-testid={`fleet-item-${i}`}
                className="p-5 sm:p-8 border border-[#E5E5E5] hover:border-[#0A0B10] transition-colors"
              >
                <Icon className="w-6 h-6 sm:w-8 sm:h-8 text-[#FF3B30] mb-3 sm:mb-4" />
                <h3 className="font-heading text-base sm:text-lg font-medium text-[#0A0B10] mb-1 sm:mb-2">{vehicle.name}</h3>
                <p className="text-xs sm:text-sm text-[#666666] leading-relaxed">{vehicle.desc}</p>
              </motion.div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
